import * as React from "react";
import { I18n } from "react-redux-i18n";

import { Loading } from "@common/components/loading";

import { TextEdit } from "../../../text-edit";
import { TextField } from "../../../text-field";
import { BackBtn } from "../../../back-btn";

import { useFinalNotesPageController } from "./final-notes-page.controller";
import { FinalNotesPageProps } from "./final-notes-page.types";
import { FieldPicker } from "../../../field-picker";
import { NOT_ALLOWED_FOR_PAGE_ADD_FIELD_TYPES } from "@modules/fhq-design-tool/constants/page";
import { Subtitle } from "../../../subtitle";
import { QuestionnaireManagementPageCustomErrors } from "@modules/fhq-design-tool/controllers/questionnaire-validation";

import "./final-notes-page.styles.scss";

export const FinalNotesPage: React.FC<FinalNotesPageProps> = (props) => {
  const { cachedData, onGoBack, errors, getFolders, getFields } = props;

  const { loadingPage, handlePageNameChange, handlePageDescriptionChange, handleFieldAdd } = useFinalNotesPageController(props);

  if (loadingPage || !cachedData) {
    return (
      <div className="FhqDesignToolQuestionnaireDesignerPage">
        <Loading size={20} margin="20px" />
      </div>
    );
  }

  return (
    <div className="FhqDesignToolQuestionnaireDesignerFinalNotesPage">
      <BackBtn className="FhqDesignToolQuestionnaireDesignerFinalNotesPage__back-btn" onClick={onGoBack} />
      <TextEdit
        errors={errors?.properties?.title}
        required
        metadata={{
          description: "page-name",
        }}
        value={cachedData.title}
        onChange={handlePageNameChange}
      />
      <Subtitle type="chip" text={I18n.t('Final Notes')} />
      <TextField
        metadata={{
          description: "page-description",
        }}
        type="textarea"
        classes={{
          label: "FhqDesignToolQuestionnaireDesignerFinalNotesPage__description-label",
          labelInputWrapper: "FhqDesignToolQuestionnaireDesignerFinalNotesPage__description-input-label-wrapper",
        }}
        label={I18n.t("Page Description")}
        value={cachedData.description ?? ""}
        onChange={handlePageDescriptionChange}
      />
      <FieldPicker
        required={cachedData.enabled}
        errors={(errors?.custom as QuestionnaireManagementPageCustomErrors | undefined)?.notesField}
        withSearch={true}
        value={(cachedData.fields?.[0]?.name || "").toString()}
        onChange={handleFieldAdd}
        metadata={{
          description: "page-field-name",
        }}
        getFields={(params) => getFields({ ...params, includeTables: true })
          .then((fields) => 
            fields.filter((x) => !NOT_ALLOWED_FOR_PAGE_ADD_FIELD_TYPES.includes(x.fieldTypeId))
          )
        }
        getFolders={getFolders}
        label={I18n.t("Final Notes")}
        labelWidth={70}
      />
    </div>
  );
};
